/*
 * @Author: 李旭
 * @Date: 2021-12-06 16:54:50
 * @LastEditTime: 2021-12-20 17:37:43
 * @LastEditors: 李旭
 * @Description:
 * @FilePath: \ems-web-ant5.0\src\models\measurer.js
 *
 */

import { useState, useCallback, useEffect } from 'react';
export default () => {
  const [protocolList, setProtocolList] = useState([]);
  const [factureList, setFactureList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [property, setPropertyList] = useState([]);
  const [dataType, setDataType] = useState([]);
  const [funcType, setFuncType] = useState([]); //功能类型
  const [readType, setReadType] = useState([]); //读写类型
  const [byteList, setByteList] = useState([]); //字节
  const [funcList, setFuncList] = useState([]); //功能类型列表
  const handleProtocolList = useCallback((data) => {
    setProtocolList(data);
  }, []);
  const handleFactureList = useCallback((data) => {
    setFactureList(data);
  }, []);
  const handleTypeList = useCallback((data) => {
    setTypeList(data);
  }, []);
  const handlePropertyList = useCallback((data) => {
    setPropertyList(data);
  });
  const handleDataProperty = useCallback((data) => {
    setDataType(data);
  });
  const handleFuncType = useCallback((data) => {
    setFuncType(data);
  });
  const handleReadType = useCallback((data) => {
    setReadType(data);
  });
  const handleByteList = useCallback((data) => {
    setByteList(data);
  });
  const handleFuncList = useCallback((data) => {
    setFuncList(data);
  });
  return {
    protocolList,
    handleProtocolList,
    factureList,
    handleFactureList,
    typeList,
    handleTypeList,
    property,
    handlePropertyList,
    handleDataProperty,
    dataType,
    funcType,
    handleFuncType,
    readType,
    handleReadType,
    byteList,
    handleByteList,
    funcList,
    handleFuncList,
  };
};
